<template>

  <div>{{ desc }}</div>

</template>

<script>

export default {
  name: 'TopActionDate',
  props: ['item'],
  computed: {
    desc () {
      switch (this.item.type) {
        case 'week':
          return this.week
        case 'month':
          return this.month
        case 'year':
          return this.year
        default:
          return 'INVALID TYPE'
      }
    },

    week () {
      return `Semaine du ${this.monday}`
    },

    monday () {
      const d = new Date(this.item.date)
      let weekday = d.getDay()
      let diff = d.getDate() - weekday + (weekday === 0 ? -6 : 1) // adjust when day is sunday
      const m = new Date(d.setDate(diff))

      const day = m.getDate().toString().padStart(2, '0')
      const month = (m.getMonth() + 1).toString().padStart(2, '0')
      const year = m.getFullYear()

      return `${day}/${month}/${year}`
    },

    month () {
      const names = [
        'de Janvier',
        'de Février',
        'de Mars',
        'd\'Avril',
        'de Mai',
        'de Juin',
        'de Juillet',
        'd\'Août',
        'de Septembre',
        'd\'Octobre',
        'de Novembre',
        'de Décembre'
      ]
      const d = new Date(this.item.date)
      return `Mois ${names[d.getMonth()]} ${d.getFullYear()}`
    },

    year () {
      const d = new Date(this.item.date)
      return `Année ${d.getFullYear()}`
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/common/TopActionDate.vue